
import React from 'react';
import { Header } from '@/components/Header';
import { TasksSection } from '@/components/TasksSection';

const Index = () => {
  return (
    <div className="min-h-screen w-full">
      <div className="container mx-auto py-1 space-y-2 min-h-screen">
        <TasksSection />
        <Header />
      </div>
    </div>
  );
};

export default Index;
